import { render, staticRenderFns } from "./CommunityPostsCard5.vue?vue&type=template&id=13a11504&"
import script from "./CommunityPostsCard5.vue?vue&type=script&lang=js&"
export * from "./CommunityPostsCard5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports